// Presentation copy only. No source values, requests, totals or export changes.
const copy = {
  tr: { open: "Tam metni göster", title: "Tam metin", close: "Kapat", currentPrice: "Güncel Fiyat", averagePrice: "Ort. Birim Fiyat" },
  en: { open: "Show full text", title: "Full text", close: "Close", currentPrice: "Current Price", averagePrice: "Avg. Unit Price" },
  ru: { open: "Показать полный текст", title: "Полный текст", close: "Закрыть", currentPrice: "Текущая цена", averagePrice: "Средняя цена за шт." },
  uz: { open: "To‘liq matnni ko‘rsatish", title: "To‘liq matn", close: "Yopish", currentPrice: "Joriy narx", averagePrice: "O‘rtacha dona narxi" },
};
export function tableReadabilityCopy(language: string) {
  return copy[language as keyof typeof copy] ?? copy.tr;
}
